import type { ReactNode } from 'react';

import { ValidationBanner } from '@/components/properties/ValidationBanner';
import { ToastContainer } from '@/components/ui/Toast';

import { BottomBar } from './BottomBar';
import { TopBar } from './TopBar';

export function AppShell({ children }: { children: ReactNode }) {
  return (
    <div className="flex h-screen w-screen flex-col overflow-hidden bg-bg">
      <TopBar />
      {/* Pack-mode-only — renders nothing in scripts. Non-blocking; teachers
          fix as they go. */}
      <ValidationBanner />
      <div className="flex min-h-0 flex-1">{children}</div>
      <BottomBar />
      <ToastContainer />
    </div>
  );
}
